export const COUNTER_VIEWS_TITLE = "Количество просмотров";
export const TEXT_ADD_TO_FAVORITES = "Добавить в Избранное";
export const TEXT_BUTTON_URL_BOARDS = "Перейти на сайт объявления";
export const TEXT_BUTTON_URL_COMPANY = "Перейти на страницу компании";
export const MIGTORG_URL = "https://www.migtorg.com/";